import gql from 'graphql-tag';

export const PatientDocumentFragment = gql`
  fragment PatientDocument on PatientDocumentRes {
    _id
    patientId
    type
    name
    mimeType
    size
    uploadedByExternal
    canDelete
    createdAt
    uploadedBy {
      _id
      firstName
      lastName
    }
  }
`;

export const GET_PATIENT_DOCUMENTS = gql`
  query GetPatientDocuments($params: PatientDocumentsInput!) {
    patientDocuments(params: $params) {
      ...PatientDocument
    }
  }
  ${PatientDocumentFragment}
`;

export const UPLOAD_PATIENT_DOCUMENT = gql`
  mutation UploadPatientDocument(
    $file: Upload!
    $params: UploadPatientDocumentInput!
  ) {
    uploadPatientDocument(file: $file, params: $params) {
      ...PatientDocument
    }
  }
  ${PatientDocumentFragment}
`;

export const PATIENT_DOCUMENT_DOWNLOAD_URL = gql`
  mutation PatientDocumentDownloadUrl($params: PatientDocumentIdInput!) {
    patientDocumentDownloadUrl(params: $params)
  }
`;

export const DELETE_PATIENT_DOCUMENT = gql`
  mutation DeletePatientDocument($params: PatientDocumentIdInput!) {
    deletePatientDocument(params: $params)
  }
`;
